import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { FormattedMessage } from '../../i18n/FormattedMessage';
import { getDateFormat } from '../../utils/utils';
import { AriesOutlinePrimaryButton } from '../../components_2/AriesButton';

/**
 * Jobs Due list row. The backend list is scoped to jobStatus Created/Assigned,
 * so every row maps to "Not Started" and offers the Start action only.
 */
const getStatusLabel = (jobStatus) =>
  jobStatus === 'Inprogress' ? 'In Progress' : 'Not Started';

const getStatusClassName = (jobStatus) =>
  jobStatus === 'Inprogress' ? 'aries-status-active' : 'aries-status-inactive';

const getAssignedTo = (technicians) => {
  if (!technicians?.length) {
    return '-';
  }
  return technicians.map((tech) => tech.customerName).join(', ');
};

const TaskListRowAries = (props) => {
  const { row, handleStartJob } = props;
  const {
    _id,
    jobId,
    createdFor,
    reportCategory,
    recurringInspectionDetails,
    startDateTime,
    type,
    price,
    technicians,
    jobStatus,
  } = row;

  const frequency = recurringInspectionDetails?.frequency;
  const startJobPayload = {
    jobId: _id,
    createdFor,
    reportCategory,
    type,
    price,
  };
  if (frequency) {
    startJobPayload.frequency = frequency;
  }

  return (
    <tr key={_id}>
      <td className="aries-jobs-due-jobid aries-jobs-due-field">
        <h3>
          <FormattedMessage id="Job Id" defaultMessage="Job Id" />
        </h3>
        <span>{jobId}</span>
      </td>
      <td className="aries-jobs-due-sitename">
        <h3>
          <FormattedMessage id="Site Name" defaultMessage="Site Name" />
        </h3>
        <span>{createdFor?.businessName}</span>
      </td>
      <td className="aries-jobs-due-field">
        <h3>
          <FormattedMessage id="Job Type" defaultMessage="Job Type" />
        </h3>
        <FormattedMessage
          id={reportCategory ?? ' '}
          defaultMessage={reportCategory ?? ' '}
        />
      </td>
      <td className="aries-jobs-due-field">
        <h3>
          <FormattedMessage id="Job Kind" defaultMessage="Job Kind" />
        </h3>
        <FormattedMessage id={type ?? ' '} defaultMessage={type ?? ' '} />
      </td>
      <td className="aries-jobs-due-field">
        <h3>
          <FormattedMessage id="Assigned To" defaultMessage="Assigned To" />
        </h3>
        <span>{getAssignedTo(technicians)}</span>
      </td>
      <td className="aries-jobs-due-field">
        <h3>
          <FormattedMessage id="Due Date" defaultMessage="Due Date" />
        </h3>
        <span>{moment(startDateTime).format(getDateFormat())}</span>
      </td>
      <td className="aries-card-status">
        <h3>
          <FormattedMessage id="Status" defaultMessage="Status" />
        </h3>
        <span className={getStatusClassName(jobStatus)}>
          <FormattedMessage
            id={getStatusLabel(jobStatus)}
            defaultMessage={getStatusLabel(jobStatus)}
          />
        </span>
      </td>
      <td className="aries-jobs-due-action">
        <AriesOutlinePrimaryButton
          size="sm"
          text="Start"
          onClick={() => handleStartJob(startJobPayload)}
        />
      </td>
    </tr>
  );
};

TaskListRowAries.propTypes = {
  row: PropTypes.object,
  handleStartJob: PropTypes.func,
};

export default TaskListRowAries;
